import { Alert, AutoThemeProvider, Table } from '@platform-ui/design-system';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import ReactHtmlParser from 'react-html-parser'; 
import $ from 'jquery';

const ApplicationsTable = (props) => {
    // Table Consts
    const [rows, setRows] = useState([])
    const [tableActions, setTableActions] = useState([])
    const [rowActions, setRowActions] = useState([]);
    const [loading, setLoading] = useState(true);
    const [noRows, setNoRows] = useState(false);
    const [searchValue, setSearchValue] = useState('')

    // Alert Consts
    const [isAlert, setIsAlert] = useState(false);
    const [alertSeverity, setAlertSeverity] = useState("success");
    const [alertHeader, setAlertHeader] = useState("");
    const [alertBody, setAlertBody] = useState("");

    // NOTE(Xander): In order to ensure the table is reloaded after certain actions, this value can be toggled
    // The reload will happen every time the value is changed, not simply when it is true
    const [reloadTable, setReloadTable] = useState(false);

    // NOTE(Xander): In order to use older Connect modals with the new table, we need to replicate Rails-Ajax functionality
    // This method ensures that all links generated by the table will render their modal on the same page without redirecting
    const ajaxCall = () => {
        $(".MuiList-root a").attr("data-remote",true);
    }

    useEffect(() => {
        getApplications(null);
    }, [reloadTable]);

    const getApplications = async (event) => {
        setLoading(true);
        try {
            const options = {
                headers: new Headers({
                    'Accept': 'application/json',
                    'Content-type': 'application/json'
                })
            };
            const response = await window.fetch(props.backend_uri, options);
            if (!response.ok) throw Error(response.statusText);
            const data = await response.json();
            setRows(data.rows);
            setTableActions(generateTableActions(data.table_actions));
            setRowActions(
                [
                    {
                        icon: 'more_horiz',
                        onClick: getRowActions,
                        listChildren: []
                    }
                ]
            );
            if (data.rows.length === 0) {
                setNoRows(true);
            } else {
                setNoRows(false);
            }
            setLoading(false);
          } catch (error) {
            console.error(error);
            setRows([]);
            setRowActions([]);
            setLoading(false);
            setNoRows(true);
        }
    }

    const apiCall = element => {
        try {
            // NOTE(Xander): This query grabs the rails CSRF token for requests
            let csrf = document.querySelector("meta[name='csrf-token']").getAttribute("content");
            fetch(element.path, {
                method: element.method,
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'X-CSRF-Token': csrf
                }
            }).then((response) => {
                setReloadTable(!reloadTable);
                if (response.status == 200 || response.ok == true) {
                    setAlertHeader("Successfully Performed Action");
                    // setAlertBody("Aren't you a cool guy!");
                    setAlertSeverity("success");
                } else {
                    setAlertHeader(`${response.status}: ${response.statusText}`);
                    setAlertBody("Please Try Again Later");
                    setAlertSeverity("error");
                }
                setIsAlert(true);
            }).catch((error) => {
                console.error(error);
            });
        } catch (error) {
            console.error(error);
        }
    }

    function generateTableActions(actions) {
        const tableActions = [
            {
                icon: "add_circle_outline",
                listChildren: []
            },
            {
                icon: "sync",
                label: "Refresh Applications",
                onClick: getApplications,
            }
        ]
        actions.forEach(element => {
            tableActions[0].listChildren.push(
                {
                    label: element.label,
                    href: element.path,
                    onClick: ajaxCall,
                    disabled: element.disabled
                }
            )
        });
        return tableActions
    }

    const getRowActions = async (event) => {
        try {
            let csrf = document.querySelector("meta[name='csrf-token']").getAttribute("content");
            const options = {
                headers: new Headers({
                    'Accept': 'application/json',
                    'Content-type': 'application/json',
                    'X-CSRF-Token': csrf
                })
            };
            const response = await window.fetch(window.location.pathname + '/' + event.row.id + '/actions', options);
            if (!response.ok) throw Error(response.statusText);
            const actions = await response.json();
            setRowActions(regenerateRowActions(actions));
        } catch (error) {
            console.error(error)
        }
    }

    function regenerateRowActions(actions) {
        return [
            {
                dsGetActionData: (row) => {
                    var listChildren = []
                    row.actions = actions
                    if (row.actions != null) {
                        var template_link = {}
                        row.actions.forEach((element) => {
                            template_link = {
                                label: element.label
                            };
                            if (element.ajaxCall) {
                                template_link.onClick = ajaxCall
                            }
                            if (element.method === "get") {
                                template_link.href = element.path
                            } else {
                                template_link.onClick = () => {
                                    apiCall(element);
                                }
                            }
                            if (element.disabled) {
                                template_link.disabled = true
                            }
                            listChildren.push(template_link);
                        });
                        return {
                            icon: 'more_horiz',
                            listChildren: listChildren,
                            onClick: getRowActions
                        };
                    }
                }
            }
        ];
    }

    return (
        <AutoThemeProvider>
            <Alert
                body={alertBody}
                dismissible
                dsOnClose={() => {
                    setIsAlert(false);
                }}
                e2e="applicationAlert"
                header={alertHeader}
                open={isAlert}
                severity={alertSeverity}
            />
            <Table
                loading={loading}
                columns={[
                    {
                        field: 'id',
                        label: 'ID',
                        labelTooltip: 'A unique identifier'
                    },
                    {
                        field: 'name',
                        label: 'Name',
                        dsRenderCell: ({value}) => {
                            return <div> {ReactHtmlParser (value)} </div>
                        }
                    },
                    {
                        field: 'default_build',
                        label: 'Default Build'
                    },
                    {
                        field: 'queue_name',
                        label: 'Queue Name'
                    },
                    {
                        field: 'created_by',
                        label: 'Owner',
                        dsRenderCell: ({value}) => {
                            return <div> {ReactHtmlParser (value)} </div>
                        }
                    },
                    {
                        field: 'updated_by',
                        label: 'Updated By',
                        dsRenderCell: ({value}) => {
                            return <div> {ReactHtmlParser (value)} </div>
                        }
                    },
                    {
                        field: 'task_count',
                        label: 'Task Count'
                    }
                  ]}
                e2e={props.table_name}
                rows={rows}
                uniqueKey={props.table_name}
                dsOnSearchChange={(args) => setSearchValue(args)}
                rowsPerPage={20}
                rowActions={rowActions}
                tableActions={tableActions}
                orderable={true}
                showNoRowsMessage={noRows}
            >
            </Table>
        </AutoThemeProvider>
    );
};

ApplicationsTable.propTypes = {
  rows: PropTypes.array
};

export default ApplicationsTable;